var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9762 11L19.0438 3.93053C19.3188 3.65599 19.3188 3.23045 19.0438 2.95591C18.7688 2.68136 18.3425 2.68136 18.0675 2.95591L10.9862 10.0254L3.91875 2.96963C3.6575 2.69509 3.2175 2.69509 2.95625 2.96963C2.695 3.24418 2.68125 3.66972 2.95625 3.93053L10.0375 11L2.95625 18.0695C2.68125 18.344 2.68125 18.7696 2.95625 19.0441C3.09375 19.1814 3.2725 19.25 3.4375 19.25C3.6025 19.25 3.795 19.1814 3.91875 19.0441L11 11.9746L18.0812 19.0441C18.2187 19.1814 18.3975 19.25 18.5625 19.25C18.7275 19.25 18.92 19.1814 19.0438 19.0441C19.3188 18.7696 19.3188 18.344 19.0438 18.0695L11.9625 11H11.9762Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-close.408334fb8064fda0af29e8ed66b6f4b2.svg";